<ion-card class="noEntriesCard selectProjectCard">
  <ion-card-header>
    <ion-icon name="warning-outline"></ion-icon>
    <ion-card-title [innerHTML]="'select_project_card_title'|translate"></ion-card-title>
  </ion-card-header>
  <ion-card-content>
    <p [innerHTML]="'select_project_card_text'|translate"></p>
  </ion-card-content>
</ion-card>